// extracted by mini-css-extract-plugin
export var actionIcon = "_kd-0";